import {
    isFunction,
    isString,
    isObject,
    upFirstLetter
} from "../funcs";
import Events from "../classes/Events";
import AppChannel from "./AppChannel";
import langDictionary from "../classes/lang/init";
import autorun from "./autorun";
import config from "./config";
import GridChannel from "./Grid/GridChannel";


export default class AppManager extends Events {
    constructor({appsToRunFromNewModules = []}) {
        super();
        system.apps = this; // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!  @see BaseApp

        let stack = [];
        AppChannel.startCatching(stack);

        this.runned = [];
        this.appsToRunFromNewModules = appsToRunFromNewModules;

        this.AppClasses = {};
        this.AppChannels = {
            // need for fix error:
            // getReportItems is not are function // Form.js
            Grid: GridChannel
        };
        this._channels = {};
        this.channel = (type) => {
            let CustomChannel = this.AppChannels[type] || AppChannel;


            let channel = this._channels[type];

            if ( !channel ) {
                channel = new CustomChannel();
                this._channels[type] = channel;
            }

            return channel;
        };

        this.autorun();

        this.once("autorun:ready", () => {
            AppChannel.fireCatched(stack);
            this.trigger("ready");
        });
    }

    async requireApp(appName, callback) {
        if ( !isFunction(callback) ) {
            callback = function(/* err, app */) {};
        }

        if ( appName in this.AppClasses ) {
            const App = this.AppClasses[appName];
            callback(null, App);
            return App;
        }

        let path = "apps/" + appName + "/" + appName + "App";
        if ( config[appName] ) {
            path = config[appName].path || path;
        }

        const [App] = await asyncRequire([
            path
        ]);

        this.registerApp(appName, App);

        callback(null, App);
        return App;
    }

    async registerApp(appName, App) {
        // for debug
        this.AppClasses[ appName ] = App;
        // @see this.channel
        if ( isFunction(App.prototype.channel) ) {
            this.AppChannels[ appName ] = App.prototype.channel();
        }
    }

    async run(appNameOrParamsOrApp, callback) {
        if ( !isFunction(callback) ) {
            callback = function(/* err, app */) {};
        }


        let App;
        let params;

        if ( isString(appNameOrParamsOrApp) ) {
            const appName = appNameOrParamsOrApp;
            const runConfig = system.getRunConfig(appName);

            if ( runConfig ) {
                params = runConfig;
                params.name = appName;
                params.runName = appName;
                params.title = langDictionary.getAppTitle(appName);
            } else {
                params = {
                    type: appName
                };
            }
        }

        else if ( isObject(appNameOrParamsOrApp) ) {
            params = appNameOrParamsOrApp;
        }

        else if ( isFunction(appNameOrParamsOrApp) ) {
            App = appNameOrParamsOrApp;
            params = {
                type: App.name.replace(/App$/, "")
            };
        }


        if ( isFunction(params.type) ) {
            App = params.type;
            params.type = App.name.replace(/App$/, "");
        }


        let appName = params.type;
        let appRunName = params.runName;

        params.title = params.title || langDictionary.getAppTitle(appName);

        system.trigger(`beforeRunApp${ appRunName ? upFirstLetter(appRunName) : ""}`, params);

        if ( !App ) {
            App = await this.requireApp(appName);
        }

        const app = await this.createApp(App, params);

        callback(null, app);
        return app;
    }

    createApp(App, params) {
        return new Promise((resolve) => {
            new App(params, (app) => {
                // возможен singleton есть app.params.single
                if ( this.runned.indexOf(app) !== -1 ) {
                    resolve(app);
                    return;
                }

                // runned apps stack
                this.runned.push(app);
                this.listenTo(app, "destroy", () => {
                    let index = this.runned.indexOf(app);
                    if ( index !== -1 ) {
                        this.runned.splice(index, 1);
                    }
                });

                // @see RunnedAppsApp
                this.trigger("run run:" + App.className, app);

                resolve(app);
            });
        });
    }

    async autorun() {
        for (const appParams of autorun) {
            await this.requireApp(appParams.type);
            await this.run(appParams);
        }

        for (const App of this.appsToRunFromNewModules) {
            const constructorName = App.name;
            const appName = constructorName.replace(/App$/, "");

            this.registerApp(appName, App);

            await this.run(appName);
        }

        // для разработчиков, открываем последний журнал, который открывали
        if ( window.appVersion == "dev" ) {
            // @see MainMenu.js
            // @see BaseApp.js
            const lastRun = localStorage.getItem("lastRun");
            if ( lastRun ) {
                system.run({ app: lastRun });
            }
        }

        this.trigger("autorun:ready");
    }
}

function asyncRequire(paths) {
    return new Promise((resolve) => {
        window.require(paths, (...exportsArr) => {
            resolve(exportsArr);
        });
    });
}
